'use client';

import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface StarRatingProps {
  value: number;
  max?: number;
  interactive?: boolean;
  size?: number;
  onChange?: (value: number) => void;
  showValue?: boolean;
}

export default function StarRating({
  value,
  max = 5,
  interactive = false,
  size = 16,
  onChange,
  showValue = false,
}: StarRatingProps) {
  const [hoverValue, setHoverValue] = useState(0);

  const displayValue = hoverValue || value;

  return (
    <div className="flex items-center gap-1">
      {Array.from({ length: max }, (_, i) => i + 1).map((star) => {
        const filled = star <= Math.floor(displayValue);
        const half = !filled && star <= displayValue + 0.5;

        return (
          <button
            key={`star-${star}`}
            type={interactive ? 'button' : undefined}
            disabled={!interactive}
            onClick={() => interactive && onChange?.(star)}
            onMouseEnter={() => interactive && setHoverValue(star)}
            onMouseLeave={() => interactive && setHoverValue(0)}
            className={`${interactive ? 'star-rating-interactive cursor-pointer' : 'cursor-default'} transition-transform duration-100`}
            aria-label={`${star} star${star !== 1 ? 's' : ''}`}
          >
            <Icon
              name={filled ? 'StarIcon' : 'StarIcon'}
              variant={filled || half ? 'solid' : 'outline'}
              size={size}
              className={filled || half ? 'rating-star-filled' : 'text-muted'}
            />
          </button>
        );
      })}
      {showValue && (
        <span className="ml-1 text-sm font-700 text-accent font-mono-nums">{value.toFixed(1)}</span>
      )}
    </div>
  );
}